import React from 'react';

function Description({ text }) {
  return <div className="text-xs tracking-tight text-gray-400">{text}</div>;
}

export default Description;
